const displayDate = new Intl.DateTimeFormat('en-US', {
  month: 'short', day: 'numeric', year: 'numeric', timeZone: 'America/Barbados',
});
const displayCalendarDate = new Intl.DateTimeFormat('en-US', {
  month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC',
});

/** An event timestamp follows Barbados local time; a due date is a calendar date. */
export function formatInvoiceDate(value: string | null | undefined, calendarDate = false): string {
  if (!value) return '—';
  const date = calendarDate && /^\d{4}-\d{2}-\d{2}/.test(value)
    ? new Date(`${value.slice(0, 10)}T12:00:00Z`)
    : new Date(value);
  if (Number.isNaN(date.valueOf())) return value.slice(0, 10);
  return (calendarDate ? displayCalendarDate : displayDate).format(date);
}
